const pluginAdvancedSitemap = require('./plugin-advanced-sitemap');

const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';

module.exports = {
    pluginAdvancedSitemap,
    activeEnv
}
